import { ReactNode } from "react";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface SectionWrapperProps {
  children: ReactNode;
  className?: string;
  title?: string;
  titleSize?: "sm" | "base" | "lg" | "xl" | "2xl" | "3xl";
}

export default function SectionWrapper({ 
  children, 
  className, 
  title,
  titleSize = "2xl" 
}: SectionWrapperProps) {
  const titleClasses = {
    sm: "text-sm",
    base: "text-base",
    lg: "text-lg",
    xl: "text-xl",
    "2xl": "text-2xl",
    "3xl": "text-3xl"
  };
  
  return (
    <Card className={cn("p-6 border-[rgb(var(--border))] shadow-sm", className)}>
      {title && (
        <h2 className={cn(
          titleClasses[titleSize],
          "font-bold text-[rgb(var(--brand))] mb-4"
        )}>{title}</h2>
      )}
      {children}
    </Card>
  );
}